export default __webpack_public_path__ + "static/media/notebook-2.d5dd64cb.svg";